export function TokenCompliancePage() {
  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-semibold">Token Compliance</h1>
      <p className="text-muted-foreground">Manage token compliance rules.</p>
    </div>
  );
}
